import http from './axios';

export interface DictDto {
  id?: number;
  // 目录
  dictCategoryId?: number;
  // 字典编码
  dictCode?: string;
  // 字典名称
  dictName?: string;
  // 上级字典编码
  parentDictCode?: string;
  // 字典分类
  dictKind?: number;
  // 字典排序
  dictSort?: number;
  // 字典标签
  dictLabel?: string;
  // 字典描述
  dictDescription?: string;
  // 使用状态，0-启用，1-禁用
  status?: number;
  // 审批状态，0：新建待提交，1-编辑待提交，2：新建已提交，3-编辑已提交，4：新建已审批，5-编辑已审批，6：新建已驳回，7-编辑已驳回
  approveStatus?: number;
  dictItemDefList?: DictItemDto[];
}

export interface DictItemDto {
  id?: number;
  // 字典编码
  dictCode?: string;
  // 条目编码
  dictItemCode?: string;
  // 条目取值
  dictItemValue?: string;
  // 条目名称
  dictItemName?: string;
  // 条目排序
  dictItemSort?: number;
  // 上级字典编码
  parentDictCode?: string;
  // 上级条目编码
  parentItemCode?: string;
  // 使用状态
  status?: number;
}

export default class DictServices {
  private readonly category_api = '/v1/dictbook/category';
  private readonly tree_api = '/v1/dictbook/tree';
  private readonly list_api = '/v1/dictbook/list';
  private readonly info_api = '/v1/dictbook/info';
  private readonly save_api = '/v1/dictbook/save';
  private readonly update_api = '/v1/dictbook/update';
  private readonly remove_api = '/v1/dictbook/delete';
  private readonly item_list_api = '/v1/dictitem/list';
  private readonly ref_list_api = '/v1/dictref/page';

  constructor() {}

  async getList(params?: object): Promise<any> {
    let res: any = await http.get(this.list_api, { params: params });
    return res.payload;
  }

  async getEnableList(params?: object): Promise<any> {
    // 0-新建待提交，1-编辑待提交，2-新建已提交，3-编辑已提交，4-新建已审批，5-编辑已审批，6-新建已驳回，7-编辑已驳回
    return await this.getList({ ...params, status_eq: 0, approveStatus_ge: 4, approveStatus_le: 5 });
  }

  async getTree(params?: object): Promise<any> {
    let res: any = await http.get(this.tree_api, { params: params });
    let list = res.payload;
    return list.map((v: any) => {
      return {
        label: v.dictDef.dictName,
        value: v.dictDef.dictCode,
        children: v.dictItemDefList.map((item: any) => ({ label: item.dictItemName, value: item.dictItemValue }))
      };
    });
  }

  async getCategory(params?: object): Promise<any> {
    let res: any = await http.get(this.category_api, { params: params });
    return res.payload;
  }

  async getItemList(params?: object): Promise<any> {
    let res: any = await http.get(this.item_list_api, { params: params });
    return res.payload;
  }

  async getRefList(params?: object): Promise<any> {
    let res: any = await http.get(this.ref_list_api, { params: params });
    return res.payload;
  }

  async getInfo(id: string | number) {
    let res: any = await http.get(this.info_api + '/' + id);
    return res.payload;
  }

  async add(data: DictDto) {
    const params = { ...data, dictSort: '1', dictCode: 'DICT_' + data.dictCode };
    let res: any = await http.post(this.save_api, params);
    return res.header?.code == 200 ? res.payload : false;
  }

  async update(data: DictDto): Promise<boolean> {
    let res: any = await http.post(this.update_api, data);
    return res.header?.code == 200;
  }

  async remove(id: string | number) {
    let res: any = await http.post(this.remove_api, [id]);
    return res.header?.code == 200;
  }

  async getItemByCode(code: string) {
    let list = await this.getItemList();
    let DICT: any = {};
    list.forEach((item: any) => {
      if (DICT[item.dictCode]) {
        DICT[item.dictCode].push({ label: item.dictItemName, value: item.dictItemValue });
      } else {
        DICT[item.dictCode] = [{ label: item.dictItemName, value: item.dictItemValue }];
      }
    });
    return DICT[code];
  }
}
